import { Alert } from "@material-tailwind/react";
import { Icon } from "@mui/material";

export function AlertBanner({ openAlert, setOpenAlert, color, Badge, message }:any) {
    return (
        <Alert open={openAlert} onClose={() => setOpenAlert(false)} style={{
              position: "fixed",
              width: "45%",
              top: "5%",
              zIndex: "50",
              left: "56%"
            }}
              animate={{
                mount: { x: 0 },
                unmount: { x: 100 },
              }}
              className="transition-transform transform ease-in-out duration-300"
              color={color}
              icon={
                <Icon className="w-6 h-6">
                    <Badge className="w-6 h-6"/>
                  {/*<ExclamationCircleIcon className="w-6 h-6" />*/}
                </Icon>
              }
            >
             {message}
            </Alert>
    );
}
